import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import CarrierTable from "./CarrierTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const CarrierMaintenance = ({ isAdmin }) => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    carriers: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/Carriers")
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          carriers: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <CarrierTable data={dataObj.carriers} isAdmin={isAdmin} />
        </div>
      )}
    </>
  );
};

export default CarrierMaintenance;
